import { BaseModel } from '@core/data-access';
import { Exclude, Expose, Type } from 'class-transformer';
import { DocumentModel } from './document.model';

@Exclude()
export class SigningVerifyingModel extends BaseModel {
  @Expose() @Type(() => DocumentModel) documents!: DocumentModel[];
}
